<template>
  <div class="svg-icon vertical-middle" :class="{ 'has-bg': _bgColor }" :style="{ 'background-color': _bgColor, 'padding': _padding, borderRadius }" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
    <Component :is="name" :isFixedColor="isFixedColor" :isTwoTone="_isTwoTone" :isSolid="_isSolid" :isGradient="_isGradient" :color="_color" :color2="_color2" :width="width" :isOutline="_isOutline" />
  </div>
</template>

<script>
export default {
  props: {
    name: { type: String, required: true },
    width: { type: Number, default: 24 },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean },
    isGradient: { type: Boolean },
    color: { type: String },
    color2: { type: String, default () { return this && this.$store.state.color['primary-200'] } },
    bgColor: { type: String },
    padding: { type: String, default: '0' },
    borderRadius: { type: String, default: '40%' },
    hasState: { type: Boolean },
    colorState: { type: Object,
      default () {
        return {
          default: { isTwoTone: false, color: this && this.$store.state.color['coolGrey-500'] },
          hover: { isTwoTone: false, bgColor: this && this.$store.state.color['coolGrey-50'], color: this && this.$store.state.color['coolGrey-900'] },
          active: { isTwoTone: true, bgColor: this && this.$store.state.color['primary-50'], color: this && this.$store.state.color['primary-500'], color2: this && this.$store.state.color['primary-200'] }
        }
      }
    },
    state: { type: String, default: 'default' },
    isActive: { type: Boolean },
    isOutline: { type: Boolean }
  },
  data () {
    return {
      currentState: this.isActive ? 'active' : this.state
    }
  },
  computed: {
    _isTwoTone () {
      return this.hasState ? Boolean(this.colorState[this.currentState].isTwoTone) : this.isTwoTone
    },
    _isSolid () {
      return this.hasState ? Boolean(this.colorState[this.currentState].isSolid) : this.isSolid
    },
    _isGradient () {
      return this.hasState ? Boolean(this.colorState[this.currentState].isGradient) : this.isGradient
    },
    _color () {
      if (this.hasState) return this.colorState[this.currentState].color
      else return this.color || this.$store.state.color[this.isTwoTone ? 'primary-500' : 'coolGrey-500']
    },
    _color2 () {
      return this.hasState ? this.colorState[this.currentState].color2 : this.color2
    },
    _bgColor () {
      return this.hasState ? this.colorState[this.currentState].bgColor : this.bgColor
    },
    _padding () {
      const statePadding = this.colorState[this.currentState].padding
      return this.hasState && statePadding ? statePadding : this.padding || ''
    },
    _isOutline () {
      return this.hasState ? this.colorState[this.currentState].isOutline : this.isOutline
    }
  },
  watch: {
    state (val) {
      this.currentState = val
    },
    isActive (val) {
      this.currentState = val ? 'active' : 'default'
    }
  },
  methods: {
    onMouseEnter () {
      if (!this.isActive) this.currentState = 'hover'
    },
    onMouseLeave () {
      if (!this.isActive) this.currentState = this.state || 'default'
    }
  }
}
</script>

<style lang="scss">
  .svg-icon {
    display: inline-block;
    line-height: 1;

    span {
      display: inline-block;
    }

    &.has-bg {
      border-radius: 40%;
    }
  }
</style>
